/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute" */
export enum ArgoAttributeConstraint {
  /** unique or primary key constraint on columns "attribute_id" */
  AttributePkey = 'attribute_pkey',
  /** unique or primary key constraint on columns "context_id", "remote_ref_id" */
  RemoteRefIdUnique = 'remote_ref_id_unique'
}

/** select columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  RemoteRefId = 'remote_ref_id',
  /** column name */
  RootAttributeId = 'root_attribute_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute" */
export enum ArgoAttributeSelectColumnArgoAttributeAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.attribute" */
export enum ArgoAttributeUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  RemoteRefId = 'remote_ref_id',
  /** column name */
  RootAttributeId = 'root_attribute_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

